import React from "react";
import "./SearchButton.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const SearchButton = ({ onClick }) => {
  const handleKeyDown = (event) => {
    console.log("registering keydown event");
    if (event.key === "Enter") {
      console.log("registering enter key");
      onClick();
    }
  };

  return (
    <button
      className="search-button"
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <FontAwesomeIcon icon={faSearch} />
    </button>
  );
};

export default SearchButton;
